module.exports = __webpack_public_path__ + "static/media/pecuaria-1.7036b440.jpg";